@if (i18n.i18nInitialized()) {
  <p-dialog [(visible)]="visible"
            [style]="{width: dialogWidth, height: dialogHeight }"
            [breakpoints]="{'1024px': '968px', '768px': '712px'}"
            [modal]="true"
            [closable]="true"
            [resizable]="false"
            [draggable]="false"
            [closeOnEscape]="false"
            (onHide)="dialogClosed()">
    <ng-template #headless>
      <div class="profile-dialog h-full">
        <div class="profile-menu">
          <div class="header">
            <div class="avatar">
              {{ authService?.userData?.avatar }}
            </div>
            <div class="user-data">
              <div class="name">
                {{ authService?.userData?.firstName }}&nbsp;{{ authService?.userData?.lastName }}
              </div>
              <div class="organisation">
                {{ authService?.organisationData?.displayCustomerNumber }}
              </div>
            </div>
          </div>
          <nav aria-label="Profile Navigation" class="menu">
            <ul role="menubar">
              @for (menuItem of menuItems; track menuItem.id) {
                <li role="none">
                  @if (menuItem?.command) {
                    <a class="menu-link"
                       role="menuitem"
                       tabindex="0"
                       [ngClass]="menuItem.active ? 'active-menu' : null"
                       (click)="commandItemClick($event, menuItem)"
                       (keydown)="onKeyDown($event)"
                       [attr.aria-label]="menuItem.i18nLabelKey ? i18n?.i18nLng()[menuItem.i18nLabelKey] : menuItem.label"
                       [pTooltip]="menuItem.label">
                      @if (menuItem?.icon) {
                        <i [ngClass]="menuItem?.icon"></i>
                      }
                      @if (!menuItem.i18nLabelKey) {
                        <span class="label">{{ menuItem.label }}</span>
                      }
                      @if (menuItem.i18nLabelKey) {
                        <span class="label">{{ i18n?.i18nLng()[menuItem.i18nLabelKey] }}</span>
                      }
                    </a>
                  }
                  @if (menuItem?.url) {
                    <a class="menu-link"
                       role="menuitem"
                       tabindex="0"
                       [href]="menuItem?.url"
                       [target]="menuItem?.target ? menuItem?.target : null"
                       [ngClass]="menuItem.active ? 'active-menu' : null"
                       (keydown)="onKeyDown($event)"
                       [attr.aria-label]="menuItem.i18nLabelKey ? i18n?.i18nLng()[menuItem.i18nLabelKey] : menuItem.label"
                       [pTooltip]="menuItem.label">
                      @if (menuItem?.icon) {
                        <i [ngClass]="menuItem?.icon"></i>
                      }
                      @if (!menuItem.i18nLabelKey) {
                        <span class="label">{{ menuItem.label }}</span>
                      } @else {
                        <span class="label">{{ i18n?.i18nLng()[menuItem.i18nLabelKey] }}</span>
                      }
                    </a>
                  }
                  @if (menuItem?.routerLink) {
                    <a class="menu-link"
                       role="menuitem"
                       tabindex="0"
                       [ngClass]="menuItem.active ? 'active-menu' : null"
                       [routerLink]="menuItem.routerLink"
                       (keydown)="onKeyDown($event)"
                       [attr.aria-label]="menuItem.i18nLabelKey ? i18n?.i18nLng()[menuItem.i18nLabelKey] : menuItem.label"
                       [pTooltip]="menuItem.label">
                      @if (menuItem?.icon) {
                        <i [ngClass]="menuItem?.icon"></i>
                      }
                      @if (!menuItem.i18nLabelKey) {
                        <span class="label">{{ menuItem.label }}</span>
                      } @else {
                        <span class="label">{{ i18n?.i18nLng()[menuItem.i18nLabelKey] }}</span>
                      }
                    </a>
                  }
                  @if (!menuItem?.command && !menuItem.url && !menuItem.routerLink) {
                    <a class="menu-link"
                       role="menuitem"
                       tabindex="0"
                       [ngClass]="menuItem.active ? 'active-menu' : null"
                       (click)="activateMenuItem(menuItem)"
                       (keydown)="onKeyDown($event)"
                       [attr.aria-label]="menuItem.i18nLabelKey ? i18n?.i18nLng()[menuItem.i18nLabelKey] : menuItem.label"
                       [pTooltip]="menuItem.label">
                      @if (menuItem?.icon) {
                        <i [ngClass]="menuItem?.icon"></i>
                      }
                      @if (!menuItem.i18nLabelKey) {
                        <span class="label">{{ menuItem.label }}</span>
                      } @else {
                        <span class="label">{{ i18n?.i18nLng()[menuItem.i18nLabelKey] }}</span>
                      }
                    </a>
                  }
                </li>
              }
            </ul>
          </nav>
        </div>
        <section aria-label="content" class="profile-content">
          <header aria-label="content header" class="header">
            <div class="title">
              {{ i18n?.i18nLng()[activeProfileId] }}
            </div>
            <div class="close-button">
              <p-button icon="pi pi-times"
                        [text]="true"
                        [rounded]="true"
                        styleClass="p-dialog-close-button"
                        severity="secondary"
                        [attr.aria-label]="i18n.i18nLng()['CLOSE']"
                        (click)="visible = false"/>
            </div>
          </header>
          <div [attr.aria-label]="'content: ' + i18n?.i18nLng()[activeProfileId]" class="content">
            @switch (activeProfileId) {
              @case ('CUSTOMERDATA') {
                <sps-profile-customer
                    [userData]="authService.userData"
                    [organisationData]="authService.organisationData"
                    titleColumnWidth="200px"
                    (onDataChanged)="enableSaveButton($event)">
                </sps-profile-customer>
              }
              <!-- remove -->
              @default {
                Inhalt
              }
            }
          </div>
          <footer aria-label="content footer" class="footer">
            @if (showCloseButton) {
              <p-button [label]="i18n?.i18nLng()['CLOSE']" severity="secondary" (click)="dialogClosed()"/>
            }
            @if (showCancelButton) {
              <p-button [label]="i18n?.i18nLng()['CANCEL']" severity="secondary" (click)="dialogClosed()"/>
            }
            @if (showSaveButton) {
              <p-button [label]="i18n?.i18nLng()['SAVE']" [disabled]="!saveEnabled" (click)="saveProfileData()"/>
            }
          </footer>
        </section>
      </div>
    </ng-template>
  </p-dialog>
}
